import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';

/** Shown when a host fetcher rejects, so a failed read never reads as an empty configuration. */
export const LoadFailed = (): ReactElement => {
  const { t } = useTranslation();

  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('config.errors.loadFailed')} />;
};
